import React from "react";
import { FileHeart, FolderLock, Gauge, LineChart, Receipt, Stethoscope } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { products } from "../content/products";

function EbIMERIS() {
  const product = products.find((p) => p.id === "imeris");

  return (
    <div>
      <Seo title="EasyBooks IMERIS" description={product.description} />
      <Hero
        eyebrow="Product"
        title="EasyBooks IMERIS"
        subtitle={product.description}
        primaryCta={{ label: "Request a demo", to: "/Contact" }}
        secondaryCta={{ label: "See ERP", to: "/EasyBooks_ERP" }}
        imageSrc={product.heroSrc}
        imageAlt="EasyBooks IMERIS"
        highlights={product.highlights}
      />

      <FeaturesGrid
        eyebrow="Healthcare platform"
        title="A unified system for better clinical and operational outcomes."
        subtitle="Connect patient records, billing, accounting, payroll, and inventory securely."
        columns={3}
        features={[
          {
            title: "Streamlined clinical workflows",
            description: "Reduce admin work with intuitive flows and smart automation for patient encounters.",
            icon: Gauge,
          },
          {
            title: "Comprehensive patient records",
            description: "Centralize history, treatment plans, labs, and medication records for informed care.",
            icon: FileHeart,
          },
          {
            title: "Medical billing & revenue",
            description: "Simplify billing and accelerate revenue cycles with better tracking and fewer denials.",
            icon: Receipt,
          },
          {
            title: "Inventory + accounting + payroll",
            description: "Integrate pharmacy/lab inventory and core finance workflows for full visibility.",
            icon: LineChart,
          },
          {
            title: "Compliance & security",
            description: "Strong controls to keep patient data confidential and accessible only to authorized users.",
            icon: FolderLock,
          },
          {
            title: "Built for medical teams",
            description: "Designed to support healthcare delivery with operational clarity and simplicity.",
            icon: Stethoscope,
          },
        ]}
      />

      <CTASection
        title="Let’s modernize your health facility."
        subtitle="We’ll help you define the rollout plan and training needed for smooth adoption."
        primaryCta={{ label: "Talk to us", to: "/Contact" }}
        secondaryCta={{ label: "Explore Accounting", to: "/EasyBooks_Accounting" }}
      />
    </div>
  );
}

export default EbIMERIS;